import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const CURRENT_SOLUTIONS: ComboBoxItem<string>[] = [
  { id: 0, label: "In-House Development", value: "In-House Development" },
  {
    id: 1,
    label: "Third-Party SaaS Platform",
    value: "Third-Party SaaS Platform",
  },
  {
    id: 2,
    label: "Custom-Built Software by a Consultant/Freelancer",
    value: "Custom-Built Software by a Consultant/Freelancer",
  },
  { id: 3, label: "Open-Source Tools", value: "Open-Source Tools" },
  {
    id: 4,
    label: "Manual Processes (No Automation)",
    value: "Manual Processes (No Automation)",
  },
  {
    id: 5,
    label: "Excel/Spreadsheet-Based Solutions",
    value: "Excel/Spreadsheet-Based Solutions",
  },
  {
    id: 6,
    label: "Generic Cloud Platform (e.g., AWS, Azure, GCP)",
    value: "Generic Cloud Platform (e.g., AWS, Azure, GCP)",
  },
  {
    id: 7,
    label: "Enterprise Software (e.g., SAP, Oracle)",
    value: "Enterprise Software (e.g., SAP, Oracle)",
  },
  {
    id: 8,
    label: "Combination of Multiple Tools/Hybrid Approach",
    value: "Combination of Multiple Tools/Hybrid Approach",
  },
  {
    id: 9,
    label: "Outsourced Development Team",
    value: "Outsourced Development Team",
  },
  {
    id: 10,
    label: "No Current Solution (Starting from Scratch)",
    value: "No Current Solution (Starting from Scratch)",
  },
  {
    id: 11,
    label: "Prototype/Experimental Model",
    value: "Prototype/Experimental Model",
  },
  {
    id: 12,
    label: "Third-Party AI/ML Service Provider",
    value: "Third-Party AI/ML Service Provider",
  },
  {
    id: 13,
    label: "API-Based Integrations with Existing Systems",
    value: "API-Based Integrations with Existing Systems",
  },
  {
    id: 14,
    label: "Others",
    value: "Others",
  },
];

export default CURRENT_SOLUTIONS;
